import http from '../api';
import Paginator from '../_paginator';

let getAll = (config) => {
  return new Paginator({
    url: 'clients',
    config: config,
  });
};

let getClient = (id) => {
  return http.get(`clients/${id}`);
};

let createClient = (data) => {
  return http.post('clients', data);
};

let updateClient = (data) => {
  return http.put(`clients/${data.id}`, data);
};

let deleteClient = (data) => {
  return http.delete(`clients/${data.id}`, {
    params: { client_quality_id: data.client_quality_id },
  });
};

export default {
  getAll,
  getClient,
  createClient,
  updateClient,
  deleteClient,
};
